
$(document).ready(function(){
  if($('#song-specific-patches').length){

      
  var tagBox = {};
  var alltags = [];
  var productBox = {};
  var ALLIDS = [];
  var arrayToFilter = [];


  //filter all tags fn
  //   function unique(list) {
  //     var result = [];
  //     $.each(list, function(i, e) {
  //       if ($.inArray(e, result) == -1) result.push(e);
  //     });
  //     return result;
  //   }




  jQuery.ajax({
    type: 'GET',
    url: '/admin/api/2021-04/collections/268783583408/products.json',
    dataType: 'json',
    success: function(response) {
          console.log(response)
      for(var i=0; i < response.products.length; i++){
        var getId = response.products[i].id;
        var getTitle = response.products[i].title;
        var getImage = response.products[i].image.src;
        var getTags = response.products[i].tags.replace(/\s/g, '');
        var getUrl = response.products[i].handle;
        var getVendor = response.products[i].vendor;

        $('.lorem.page-width').append('<a href="/products/'+getUrl+'" class="item" data-id="'+getId+'" data-tags="'+getTags+'"><div class="image"><img src="'+getImage+'"></div><div class="title"><h4>'+getTitle+'</h4></div><div class="tags"><p>Tags : '+getTags+'</p></div><div class="software">'+getVendor+'</div></a>');


        productBox = {
          id: getId,
          title: getTitle,
          image: getImage,
          tags: getTags.split(','),
          getUrl: getUrl,
          getVendor: getVendor
        }
        ALLIDS.push(productBox);


        var splittedTags = getTags.split(',');
        for(var p=0; p < splittedTags.length; p++){
          alltags.push(splittedTags[p]);
        }

        //add only new tags to array
        var norepeatedtags = alltags.filter(function(elem, index, self) {
          return index === self.indexOf(elem);
        });
      }  
      //create tag filter
      for(var b=0; b < norepeatedtags.length; b++){
        $('.filter-wrap.page-width').append('<div class="tag-wrapper" data-tags="'+norepeatedtags[b]+'"><p>'+norepeatedtags[b]+'</p></div>')
      }


    },

    error: function(data, textstatus) {

    },
  });




  $(document).ajaxComplete(function( event, xhr, settings ) {

    function filterItems(el){
      var getTagName = el.text();
      // console.log(getTagName);

      function startFiltering(){  
        for (var i=0; i < ALLIDS.length; i++){
          var tagToCompare = ALLIDS[i].tags;
          var idToCompare =  ALLIDS[i].id;
          //console.log(idToCompare)
          //go through all tags if more than 1
          for (var a=0; a < ALLIDS[i].tags.length; a++){     
            if(getTagName == ALLIDS[i].tags[a]){
              if($('.lorem.page-width .item[data-id="'+ALLIDS[i].id+'"]').length){

                //      console.log('already exist')
              }else{
                $('.lorem.page-width').append('<a href="/products/'+ALLIDS[i].getUrl+'" class="item" data-id="'+ALLIDS[i].id+'" data-tags="'+ALLIDS[i].tags+'"><div class="image"><img src="'+ALLIDS[i].image+'"></div><div class="title"><h4>'+ALLIDS[i].title+'</h4></div><div class="tags"><p>Tags : '+ALLIDS[i].tags+'</p></div><div class="software">'+ALLIDS[i].getVendor+'</div></a>');

                //  console.log('no')
              }
            }
          }
        }   
      }
      function startFiltering2(){
        var getActiveItems = $('.filter-wrap .tag-wrapper.active');
        var arrToCompare = [];
        $('.filter-wrap .tag-wrapper.active').each(function(){
          var getAllActive = $(this).attr('data-tags').split(',');
          arrToCompare.push(getAllActive)	
        })
        console.log(arrToCompare)
        for (var i=0; i < ALLIDS.length; i++){
          var tagToCompare = ALLIDS[i].tags;
          var idToCompare =  ALLIDS[i].id;
          for(var m=0; m < arrToCompare.length; m++){
            for (var a=0; a < ALLIDS[i].tags.length; a++){     
              if(arrToCompare[m] == ALLIDS[i].tags[a]){
                if($('.lorem.page-width .item[data-id="'+ALLIDS[i].id+'"]').length){
                  //check if item exist in DOM
                }else{
                  $('.lorem.page-width').append('<a href="/products/'+ALLIDS[i].getUrl+'" class="item" data-id="'+ALLIDS[i].id+'" data-tags="'+ALLIDS[i].tags+'"><div class="image"><img src="'+ALLIDS[i].image+'"></div><div class="title"><h4>'+ALLIDS[i].title+'</h4></div><div class="tags"><p>Tags : '+ALLIDS[i].tags+'</p></div><div class="software">'+ALLIDS[i].getVendor+'</div></a>');
                }
              }
            }
          }


        }   
      }

      //check if active is
      if(!$('.filter-wrap.page-width .tag-wrapper p:not(.all)').parent().hasClass('active')){
        $('.lorem.page-width').html('');
      }

      //check if active already exist on item

      //if clicked element is active - remove class, or add class if not active
      if(el.parent().hasClass('active')){
        $(el.parent().removeClass('active'));
        $('.lorem.page-width').html('');        
        startFiltering2();
        //


      }else{
        el.parent().addClass('active');
        startFiltering();
      }


      //if no one of elemets aren't active simulate click on all 
      if(!$('.filter-wrap.page-width .tag-wrapper p:not(.all)').parent().hasClass('active')){
        $('.filter-wrap.page-width .tag-wrapper p.all').click();
        // console.log('not any of item is active')
      }




    }

    $('.filter-wrap.page-width .tag-wrapper p:not(.all)').on('click', function(){
      $('.filter-wrap.page-width .tag-wrapper p.all').parent().removeClass('active');
      filterItems($(this));

    })



    $('.filter-wrap.page-width .tag-wrapper p.all').on('click', function(){
      
      
      $('.filter-wrap.page-width .tag-wrapper p:not(.all)').parent().removeClass('active');

      if($(this).parent().hasClass('active')){

      }else{
        $(this).parent().addClass('active');
        $('.lorem.page-width').html('');
        for (var i=0; i < 5; i++){
          $('.lorem.page-width').append('<a href="/products/'+ALLIDS[i].getUrl+'" class="item" data-id="'+ALLIDS[i].tags+'" data-tags="'+ALLIDS[i].tags+'"><div class="image"><img src="'+ALLIDS[i].image+'"></div><div class="title"><h4>'+ALLIDS[i].title+'</h4></div><div class="tags"><p>Tags : '+ALLIDS[i].tags+'</p></div><div class="software">'+ALLIDS[i].getVendor+'</div></a>');
        }
      }

    })


  });


  //   jQuery.ajax({
  //     type: 'GET',
  //     url: '/admin/api/2021-04/pages/filters-page.json',
  //     dataType: 'json',
  //     success: function(response) {
  //       console.log(response);
  //       //       for(var i=0; i < response.products.length; i++){
  //       //         $('.lorem.page-width').append('<div class="item"><div class="image"><img src="'+getImage+'"></div><div class="title"><h4>'+getTitle+'</h4></div><div class="tags"><p>Tags : '+getTags+'</p></div></div>') 
  //       //         console.log(response)
  //       //       }      
  //     },

  //     error: function(data, textstatus) {

  //     },
  //   });
}

})

